<template>
    <figure class="gg-image">
      <ShImage class="img" :srcset="imageSrc" :alt="imageAlt" />
      <figcaption class="gg-credit">
        <span aria-hidden="true" v-if="imageAttrs.imageCaption">{{ imageAttrs.imageCaption }}</span>
        <span aria-hidden="true" v-if="imageAttrs.imageCredit">({{ imageAttrs.imageCredit }})</span>
      </figcaption>
    </figure>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { ShImage } from '@sohohouse/design-system'
import { processScImage } from '~/helpers/cloudinary-adapter'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  components: {
    ShImage
  },

  name: 'GridGalleryImage',

  props: {
    fields: {
      type: Object
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    imageAttrs () {
      return this.fields.image
        && this.fields.image.value
    },

    imageSrc () {
      const processed = processScImage(this.imageAttrs, 'cloudinary_image_url_large')

      return processed.src
    },

    imageAlt () {
      const { imageCredit } = this.imageAttrs

      if (!imageCredit) return this.imageAttrs.alt

      return `${this.imageAttrs.alt} (${imageCredit})`
    }
  }
}
</script>

<style lang="scss" scoped>

.gg-image {
  display: inline-block;
  width: 100%;
  padding-bottom: $space-080;
  margin: 0;
  box-sizing: content-box;

  &:last-child {
    padding-bottom: $space-060;
  }

  @include tablet {
    width: 47%;
    padding: 0 0 $space-090 6%;

    &:last-child {
      padding-bottom: $space-090;
    }

    &:nth-child(2n-1) {
      padding-left: 0;
    }
  }

  @include desktop {
    padding-left: 4.3%;
    width: 30.5%;

    &:nth-child(2n-1) {
      padding-left: 4.1%;
    }

    &:nth-child(3n-2) {
      padding-left: 0;
    }
  }

  .img {
    max-width: 100%;
  }
}

.gg-credit {
  @include font('030');

  display: table-cell;
  text-align: initial;
  color: $color-slate-dark;
}

</style>
